import React from "react";

export const Person = (props) => {
  const { width, height, color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 56 56" fill={color}>
      <path fillRule="evenodd" clipRule="evenodd" d="M40.3528 17.0122C40.3528 23.8653 34.858 29.3604 28.0001 29.3604C21.1446 29.3604 15.6475 23.8653 15.6475 17.0122C15.6475 10.1592 21.1446 4.66644 28.0001 4.66644C34.858 4.66644 40.3528 10.1592 40.3528 17.0122ZM28 51.3332C17.8789 51.3332 9.33337 49.6882 9.33337 43.3415C9.33337 36.9924 17.9326 35.4057 28 35.4057C38.1235 35.4057 46.6667 37.0507 46.6667 43.3975C46.6667 49.7465 38.0675 51.3332 28 51.3332Z" fill={window?.settings?.primary_color ?? '#1DBD6B'} />
    </svg>
  )
}
